export const TITLE_MAX_LENGTH = 40
export const DESCRIPTION_MAX_LENGTH = 150
export const getLengthLimitError = (value: string, maxLength: number) =>
    Array.from(value).length > maxLength ? `Превышен лимит: максимум ${maxLength} символов` : undefined
